module.exports = __webpack_public_path__ + "images/category_lp/jewel/assessment_achievements/3_e7a98f109cf9f37326e765be201b7933.jpg";